<template>
  <button
    type="button"
    class="cliente-icon-btn"
    :class="[`cliente-icon-btn--${variant}`, { 'cliente-icon-btn--labeled': !!label }]"
    :aria-label="ariaLabel"
    :title="ariaLabel"
    @click="$emit('click', $event)"
  >
    <svg v-if="variant === 'edit'" class="cliente-icon-btn__svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
    </svg>
    <svg v-else-if="variant === 'delete'" class="cliente-icon-btn__svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
    </svg>
    <svg v-else class="cliente-icon-btn__svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
    </svg>
    <span v-if="label" class="cliente-icon-btn__label">{{ label }}</span>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  variant: {
    type: String,
    default: 'add',
    validator: (v) => ['add', 'edit', 'delete'].includes(v)
  },
  label: { type: String, default: '' }
})

defineEmits(['click'])

const { t } = useI18n()

const ariaLabel = computed(() => {
  if (props.label) return props.label
  if (props.variant === 'edit') return t('common.edit')
  if (props.variant === 'delete') return t('common.delete')
  return t('common.add')
})
</script>

<style scoped>
.cliente-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.cliente-icon-btn:active {
  transform: scale(0.96);
}
.cliente-icon-btn__svg {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}
.cliente-icon-btn--edit,
.cliente-icon-btn--delete {
  width: 2rem;
  height: 2rem;
  padding: 0;
}
.cliente-icon-btn--edit {
  color: #0284c7;
  background: #f0f9ff;
  border-color: #bae6fd;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.12);
}
.cliente-icon-btn--edit:hover {
  color: #0369a1;
  background: #e0f2fe;
  border-color: #7dd3fc;
}
.cliente-icon-btn--delete {
  color: #dc2626;
  background: #fef2f2;
  border-color: #fecaca;
  box-shadow: 0 1px 2px rgba(239, 68, 68, 0.1);
}
.cliente-icon-btn--delete:hover {
  color: #b91c1c;
  background: #fee2e2;
  border-color: #fca5a5;
}
.cliente-icon-btn--add.cliente-icon-btn--labeled {
  min-height: 2rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.3);
}
.cliente-icon-btn--add.cliente-icon-btn--labeled:hover {
  background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
}
.cliente-icon-btn--add.cliente-icon-btn--labeled .cliente-icon-btn__svg {
  width: 0.875rem;
  height: 0.875rem;
}
.cliente-icon-btn__label {
  white-space: nowrap;
  line-height: 1.2;
}
</style>
